export default __webpack_public_path__ + "static/img_llomis_pay.png";